import React from "react";

const ToolsOptions = ({ data }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-evenly",
        alignItems: "center",
        width: "100%",
        height: "100%",
      }}
    >
      {data}
    </div>
  );
};

export default ToolsOptions;
